// A child's own plans (B3; mockup 02 "+ Add to Wednesday"): what, when, and maybe a place from
// their want list. Only when their controls allow ("own plans" or "any unlocked plan"); the
// server checks the same rules and the locks (worker/edits.ts). Grown-up things (plays, locks,
// bookings, surprises) aren't offered here.
import { useMemo, useState } from 'react'
import type { Person } from '../../shared/events'
import type { DayItem, Pack } from '../../shared/pack/schema'
import { closeOverlay } from '../app/router'
import { Sheet } from '../app/Sheet'
import { useEvents } from '../data/progress'
import { myPlaces } from '../domain/places'
import { newItemId, removeItem, setItem } from '../plan/writes'
import { fmt, t } from '../strings/en'

export function MyPlanSheet({ pack, person, date, item }: { pack: Pack; person: Person; date: string; item: DayItem | null }) {
  const events = useEvents()
  const wanted = useMemo(() => [...myPlaces(events, person.id).wanted.keys()].flatMap((id) => pack.places.find((p) => p.id === id) ?? []), [events, person.id, pack.places])
  const [title, setTitle] = useState(item?.title ?? '')
  const [time, setTime] = useState(item?.time ?? '')
  const [placeId, setPlaceId] = useState<string | undefined>(item?.placeId)

  const save = async () => {
    const fields = { date, title: title.trim(), time: time || null, placeId: placeId ?? null, ...(item ? {} : { booked: false, by: person.id }) }
    await setItem(pack.meta.id, item?.id ?? newItemId(), fields, person.id)
    closeOverlay()
  }

  return (
    <Sheet title={item ? t.myPlan.edit : t.myPlan.add(fmt.day(date))}>
      <label className="field">
        <small>{t.myPlan.what}</small>
        <input value={title} maxLength={80} onChange={(e) => setTitle(e.target.value)} />
      </label>
      <label className="field" style={{ marginTop: 10 }}>
        <small>{t.myPlan.when}</small>
        <input type="time" value={time} onChange={(e) => setTime(e.target.value)} />
      </label>
      {wanted.length ? (
        <>
          <p className="mono sheet-sub">{t.myPlan.where}</p>
          <div className="chips">
            {wanted.map((p) => (
              <button
                key={p.id}
                className={`chip press${placeId === p.id ? ' on' : ''}`}
                aria-pressed={placeId === p.id}
                onClick={() => {
                  setPlaceId(placeId === p.id ? undefined : p.id)
                  if (!title.trim()) setTitle(p.name)
                }}
              >
                📍 {p.name}
              </button>
            ))}
          </div>
        </>
      ) : null}
      <button className="btn y press" style={{ marginTop: 16 }} disabled={!title.trim()} onClick={() => void save()}>
        {item ? t.myPlan.save : t.myPlan.addIt}
      </button>
      {item ? (
        <button
          className="btn w press person-remove"
          onClick={() => {
            void removeItem(pack.meta.id, item.id, person.id).then(closeOverlay)
          }}
        >
          {t.myPlan.remove}
        </button>
      ) : null}
      <p className="caption">{t.myPlan.note}</p>
    </Sheet>
  )
}
